import { Settings } from "@mui/icons-material"
import { Grid, IconButton, Tooltip, Typography, useTheme } from "@mui/material"
import { Stack } from "@mui/system"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Config, Schedule } from "../../../api/AutoArmConfig"
import { AutoArmConfigDialog } from "./AutoArmConfigDialog"
import { AutoArmToggle } from "./AutoArmToggle"

type Props = {
    config: Config
    readOnly: boolean
    saveConfig: (config?: Schedule, enabled?: boolean) => Promise<boolean>
}

export const AutoArmConfigButton = ({ config, readOnly, saveConfig }: Props) => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation()
    const theme = useTheme()

    return (
        <Grid item xs={12} sm={6} md={4} lg={3}>
            <Stack
                direction="row"
                px={1}
                height="100%"
                sx={{ alignItems: "center", backgroundColor: theme.palette.background.paper }}
            >
                <Stack
                    direction="row"
                    sx={{
                        alignItems: "center",
                        flexGrow: 1,
                        overflow: "hidden",
                    }}
                >
                    <AutoArmToggle
                        value={config.enabled}
                        disabled={readOnly}
                        onChange={(v) => saveConfig(config.schedule, v)}
                    />
                    <Typography
                        sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {t("alarm.auto_arm")}
                    </Typography>
                    <Tooltip title={t("dialog.auto_arm.edit_schedule_tooltip")}>
                        <IconButton
                            sx={{ color: theme.palette.primary.main, marginLeft: "auto" }}
                            onClick={() => setOpen(true)}
                        >
                            <Settings />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </Stack>

            {open && (
                <AutoArmConfigDialog
                    initialConfig={config}
                    readOnly={readOnly}
                    onClose={() => setOpen(false)}
                    saveConfig={saveConfig}
                />
            )}
        </Grid>
    )
}
